import React from "react";
import { Autosuggest, FormField } from "@amzn/awsui-components-react";

/** Common reasons offered when moving a case to Blocked; free text is still accepted. */
export const COMMON_BLOCKER_REASONS = [
  "Upstream issue",
  "Waiting on fix deployment",
  "Waiting on another team",
  "Waiting on data correction",
  "Needs business decision",
];

interface BlockerReasonFieldProps {
  value: string;
  onChange: (value: string) => void;
  description?: string;
}

/** "Blocker reason" input: pick a common reason or type your own. */
export const BlockerReasonField: React.FC<BlockerReasonFieldProps> = ({
  value,
  onChange,
  description,
}) => (
  <FormField
    label="Blocker reason"
    description={description}
    errorText={!value.trim() ? "Required" : undefined}
  >
    <Autosuggest
      value={value}
      onChange={({ detail }) => onChange(detail.value)}
      options={COMMON_BLOCKER_REASONS.map((r) => ({ value: r }))}
      enteredTextLabel={(v) => `Use: "${v}"`}
      placeholder="Pick a common reason or type your own"
      ariaLabel="Blocker reason"
      empty="No matching common reason"
    />
  </FormField>
);
